var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(this.$store.getters['limits/isLoadingTypesForSelect'])?_c('i',{staticClass:"fas fa-spinner fa-pulse"}):_vm._e(),_vm._v(" "+_vm._s(this.format)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }